﻿import * as XLSX from '@e965/xlsx';
import { saveAs } from 'file-saver';
import { message } from '../../components/antdMessageBridge';

/**
 * Exports data to an Excel file.
 * @param {Array<object>} dataSource - The data to export.
 * @param {Array<object>} columns - The column definitions from the antd table.
 * @param {string} filename - The desired name for the Excel file.
 */
export const exportToExcel = (dataSource, columns, filename) => {
    // Failsafe: Don't attempt to download if there's no data
    if (!dataSource || dataSource.length === 0) {
        message.warning("The grid is currently empty. There are no records to export");
        return;
    }

    // Extract headers from columns
    const headers = columns.map(col => col.title);

    // Map the data to only include keys present in the columns
    const formattedData = dataSource.map(item => {
        const row = {};
        columns.forEach(col => {
            if (typeof col.dataIndex === 'string' && col.dataIndex.includes('.')) {
                const nestedKeys = col.dataIndex.split('.');
                let nestedValue = item;
                nestedKeys.forEach(key => {
                    if (nestedValue) {
                        nestedValue = nestedValue[key];
                    }
                });
                row[col.dataIndex] = nestedValue;
            } else {
                row[col.dataIndex] = item[col.dataIndex];
            }
        });
        return row;
    });

    // Convert the array of objects to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    // Override the headers in the worksheet
    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: 'A1' });

    // Set column widths (wch = width in characters)
    worksheet['!cols'] = columns.map(col => ({
        wch: col.width ? col.width / 7 : 20 // Convert px → roughly characters
    }));

    // Create a new workbook and add the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Generate a blob and trigger the download
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(blob, `${filename}.xlsx`);
};